
























































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class PunishmentWhen extends GlobalMixins {
	isInitializing: boolean = true
	hasInteracted: boolean = false

	amount: number | null = null
	timeNotation: string = 'days'

	@Watch('amount')
	@Watch('timeNotation')
	onChange() {
		if (this.isInitializing) return

		this.hasInteracted = true
		this.checkTimeNotationValid()
	}
	
	get amountWrong(): boolean {
		if (!this.hasInteracted) return false
		if (!this.amount) return true
		if (this.amount <= 0) return true

		return false
	}

	checkTimeNotationValid(): void {
		const isComplete =
			this.amount !== null &&
			this.amount > 0 &&
			this.timeNotation !== 'none'

		if (isComplete) {
			this.$store.dispatch('setPunishmentLength', {
				amount: this.amount,
				timeNotation: this.timeNotation
			})
			bus.$emit('setNextButton', 'next')
		} else {
			this.$store.dispatch('setPunishmentLength', false)
			bus.$emit('setNextButton', false)
		}
	}

	mounted() {
		bus.$emit('setNextButton', false)
		bus.$on('goToNextScreen', () => {
			this.$router.push({ name: this.language === Languages.NL ? 'results' : 'results-'+this.language })
		})

		if (
			this.$store.getters.user.punishmentLength &&
			this.$store.getters.user.punishmentLength !== 'skipped'
		) {
			this.amount = this.$store.getters.user.punishmentLength.amount
			this.timeNotation = this.$store.getters.user.punishmentLength.timeNotation
		}

		this.$nextTick(() => {
			this.isInitializing = false
			this.checkTimeNotationValid()
		})
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}
}
